/**************
 Cart
 ***************/


// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // check if mystery gift in cart


    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    let productIDToCollectionsHandles = cartData.productIDToCollectionsHandles;

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // check if free mystery loop is in the cart, if so, make sure it has a quantity of 1
    let freeMysteryLoopProductID = 9023281955056;
    let freeMysteryLoopsInCart = cart.items.filter(item => item.product_id === freeMysteryLoopProductID);

    if (freeMysteryLoopsInCart.length > 1) {
        let updatePayload = {};

        // remove the last free mystery loop if there are more than one
        let lastMysteryLoop = freeMysteryLoopsInCart.pop();


        // // update the quantity of the last free mystery loop to 0
        updatePayload[lastMysteryLoop.key] = 0;
        cart = await updateCart({updates: updatePayload});
        await openCart(true);
    }


    // check if free mystery loop is in the cart, if so, make sure it has a quantity of 1
    let freeMysteryLoopInCart = cart.items.find(item => item.product_id === freeMysteryLoopProductID);
    if (freeMysteryLoopInCart && freeMysteryLoopInCart.quantity > 1) {
        let updatePayload = {};
        updatePayload[freeMysteryLoopInCart.key] = 1;
        cart = await updateCart({updates: updatePayload});
        await openCart(true);

    }


    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerBodyLinksCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitleCount").textContent = `${cart.item_count}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // update gifts bar
    if (cartSettings.show_gifts) {

        // get the items in the cart that are inside the gifts collection (giftTriggerCollection)
        let giftItems = cart.items.filter(item => {
            return productIDToCollectionsHandles[item.product_id].includes(giftTriggerCollection.handle);
        });

        // tally the quantity of gift items in the cart
        let giftItemsTotalQty = giftItems.reduce((acc, item) => {
            return acc + item.quantity;
        }, 0);


        // find the checkpoints for the gifts in cart
        let checkpoints = {};
        document.querySelectorAll('.miniCartHeaderGiftsBarItem').forEach((item, index) => {
            let checkpoint = parseInt(item.dataset.checkpoint);
            checkpoints[index] = {
                quantity: checkpoint, // amount required to reach this checkpoint
                element: item,
                gift: item.dataset.text
            }
        })


        // find which checkpoint the cart is at
        let checkpoint = 0;
        for (let i = 0; i < Object.keys(checkpoints).length; i++) {
            let currentCheckpoint = checkpoints[i];
            if (giftItemsTotalQty >= currentCheckpoint.quantity) {
                checkpoint = i + 1;
            } else {
                break;
            }
        }

        // // update header text
        // if (checkpoint === 0) {
        //     document.querySelector('#miniCartHeaderText').textContent = "Buy 2 Get 1 Free"
        // } else {
        //     document.querySelector('#miniCartHeaderText').textContent = "Buy 1 Get 1 Free"
        // }


        // there are three mini progress bars for different tiers of gifts, update each one
        document.querySelectorAll('.miniCartHeaderGiftsBarItem').forEach((element, index) => {

            // check if we've reached any checkpoints
            if (checkpoint >= index + 1) {
                // fill up the progress bar
                element.querySelector('.miniCartHeaderGiftsBarItemLeftProgressInner').style.width = "100%";

                // show the checkmark
                element.querySelector('.miniCartHeaderGiftsBarItemCheckpoint').classList.add('active');
            } else {
                element.querySelector('.miniCartHeaderGiftsBarItemLeftProgressInner').style.width = "0%";
                element.querySelector('.miniCartHeaderGiftsBarItemCheckpoint').classList.remove('active');
            }

            // check if we're in progress between a checkpoint
            if (checkpoint === index) {
                let percent = Math.round((giftItemsTotalQty / checkpoints[index].quantity) * 100);

                element.querySelector('.miniCartHeaderGiftsBarItemLeftProgressInner').style.width = `${percent}%`;
            }

            // update gift bar text
            // calculate the number of gifts needed to reach the next checkout
          
          //  let currentCheckpoint = checkpoints[checkpoint];
           // if (currentCheckpoint) {
             //   let giftsNeeded = (currentCheckpoint.quantity - giftItemsTotalQty);
               // let giftWord = giftsNeeded === 1 ? 'Band' : 'Bands';
                //document.querySelector('#miniCartHeaderGiftsTxt').innerHTML = `Add ${giftsNeeded} More ${giftWord} to Unlock <strong>${currentCheckpoint.gift}!</strong>`;

         //   } else {
                // success, all gifts unlocked
           //     document.querySelector('#miniCartHeaderGiftsTxt').innerHTML = `${cartSettings.success_text}`;
         //   }

         // giftItemsTotalQty = total number of bands in the mini cart
let bandsInCart = giftItemsTotalQty;
let headerEl = document.querySelector('#miniCartHeaderGiftsTxt');

if (bandsInCart >= 5) {
    // 5 or more bands – final state
    // Use your existing success text or hard-code if you prefer
    headerEl.innerHTML = `${cartSettings.success_text}`;
    
} else if (bandsInCart === 4) {
    // Exactly 4 bands
    headerEl.innerHTML = `Congratulations, you're getting <strong>2 FREE bands</strong>! <br><div style="font-size:14px; padding-top:5px;">Check out now or add 1 more for additional savings!</div>`;
    
} else if (bandsInCart === 3) {
    // Exactly 3 bands
    headerEl.innerHTML = `Nice! You have added your first <strong>FREE band</strong>, now add 1 more!.`;
    
} else if (bandsInCart === 2) {
    // Exactly 2 bands
    headerEl.innerHTML = `You have unlocked <strong>2 FREE bands!</strong> Now add any 2 bands to your cart, they'll be FREE.`;
    
} else {
    // Below 2 bands → keep your original progress behavior
    let currentCheckpoint = checkpoints[checkpoint];

    if (currentCheckpoint) {
        let giftsNeeded = (currentCheckpoint.quantity - bandsInCart);
        let giftWord = giftsNeeded === 1 ? 'Band' : 'Bands';

        headerEl.innerHTML = `Add ${giftsNeeded} More ${giftWord} to Unlock <strong>${currentCheckpoint.gift}!</strong>`;
    } else {
        // safety fallback
        headerEl.innerHTML = `${cartSettings.success_text}`;
    }
}


        });
    }


    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }
            let HTML = "";

            // show all options
            item.options_with_values.forEach(option => {
                HTML += `
               <div class="miniCartBodyItemVariant">${option.name}: ${option.value}</div>
               `
            });

            return HTML;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // discount HTML
        function discountHTML() {
            let HTML = "";

            // check for discount
            if (item.line_level_discount_allocations.length === 0) {
                return "";
            }

            HTML = `<div class="miniCartBodyItemDiscount">
                        <svg class="discount-allocations-tags-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>
                        ${item.line_level_discount_allocations[0].discount_application.title}
                    </div>`;

            return HTML;
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/
            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount

            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            // if (comparePrice) {
            //     console.log('compare')
            //     let savings = comparePrice - item.final_line_price;
            //     if (savings > 0) {
            //         HTML += `<span>(Save ${price(savings, false)})</span>`;
            //     }
            // }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}"
                >
               ${sellingPlanName}
                </button>
            `;
        }

        // hide quantity if product is free
        function customCSS() {
            let css = "";
            if (item.price === 0) {
                css = "freeStyling";
            }
            return css;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${subscriptionHTML()}
                            ${discountHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex ${customCSS()}" >
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="#7A7A7A" fill-rule="nonzero"></path></svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg>
                            </button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
          
                ${upgradeHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

// check if cart contains an upsell item
document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
    // Skip variant A/B upsells here; they are handled separately below
    if (element.classList.contains('miniCartUpsellItem--variant')) {
        return;
    }

    // CONTROL upsells: hide entire product if any variant is in the cart
    let productID = parseInt(element.dataset.product);
    let isProductInCart = cart.items.find(item => item.product_id === productID);

    if (isProductInCart) {
        element.classList.remove("active");
    } else {
        element.classList.add("active");
    }
});
// VARIANT-BASED UPSELL (A/B version) – filter by Bandwidth + exact variant in cart
const validBandwidths = ['38/40/41/42MM', '44/45/46/49MM'];

let cartBandwidth = null;

// find first valid Bandwidth on any cart line
cart.items.forEach(item => {
    if (cartBandwidth) return;
    if (!item.options_with_values) return;

    item.options_with_values.forEach(opt => {
        if (opt.name === 'Bandwidth' && validBandwidths.includes(opt.value.trim())) {
            cartBandwidth = opt.value.trim();
        }
    });
});

const cartVariantIDs = cart.items.map(item => item.variant_id);

document.querySelectorAll(".miniCartUpsellItem--variant").forEach(element => {
    const variantID = parseInt(element.dataset.variant, 10);
    const bandwidth = (element.dataset.bandwidth || "").trim();

    let shouldShow = true;

    // must match the cart bandwidth
    if (!cartBandwidth || bandwidth !== cartBandwidth) {
        shouldShow = false;
    }

    // hide if that exact variant is already in the cart
    if (cartVariantIDs.includes(variantID)) {
        shouldShow = false;
    }

    if (shouldShow) {
        element.classList.add("active");
    } else {
        element.classList.remove("active");
    }
});




    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // update price
    document.querySelector("#miniCartFooterReceiptTotal").querySelector('.miniCartFooterReceiptTxt.total').textContent = price(cart.total_price);

    // Update discounts if there are any
    document.querySelector("#miniCartFooterReceiptDiscounts").classList.remove("active");
    let hasDiscount = cart.items.some(item => {
        if (item.line_level_discount_allocations.length > 0) {
            // show discount & amount
            document.querySelector("#miniCartFooterReceiptDiscounts").classList.add("active");
            document.querySelector(".miniCartFooterReceiptTxtTag").innerHTML = `
            <svg class="footer-tags-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>
            ${item.line_level_discount_allocations[0].discount_application.title}
            `;
            document.querySelector("#miniCartFooterReceiptDiscounts").querySelector('.miniCartFooterReceiptTxt.discount').textContent = `-` + price(cart.total_discount);
            return true;
        }
        return false;
    });

    if (cart.cart_level_discount_applications.length > 0) {
        document.querySelector("#miniCartFooterReceiptDiscounts").classList.add("active");
        document.querySelector(".miniCartFooterReceiptTxtTag").innerHTML = `
      <svg class="footer-tags-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>
      ${cart.cart_level_discount_applications[0].title ?? cart.cart_level_discount_applications[0].discount_application.title}
      `;
        document.querySelector("#miniCartFooterReceiptDiscounts").querySelector('.miniCartFooterReceiptTxt.discount').textContent = `-` + price(cart.total_discount);
    }

}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemATC').forEach(function (element) {
    element.addEventListener("click", async function () {

        // if this upsell has variants, open the variant selector
        if (element.classList.contains('openVariants')) {
            return;
        }

        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        document.querySelector("#miniCartContent").classList.remove("loading");

        await openCart();
    });
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // if the free mystery loop is the only item in the cart, don't let them check out
    let freeMysteryLoopProductID = 9023281955056;
    let freeMysteryLoopInCart = cart.items.find(item => item.product_id === freeMysteryLoopProductID);
    if (cart.item_count === 1 && freeMysteryLoopInCart) {
        alert("You must have at least one paid item in your cart to checkout.");
        return;
    }


    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };


    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


/**************
 Variant upsells
 *************/

// close event
document.querySelectorAll(".variantUpsell")?.forEach(function (element) {
    element.addEventListener("close", function () {
    });
});

// open gallery event listener
document.querySelectorAll(".openVariants")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
    });
});

//close gallery event listener
document.querySelectorAll(".variantUpsellClose")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".variantUpsell")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.variantUpsell")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

// listen for select change
document.querySelectorAll('.variantUpsellOptionsSelect')?.forEach(function (element) {
    element.addEventListener("change", function () {
        updateUpsell(element);
    });
});

// update upsell
function updateUpsell(element) {
    let upsellElement = element.closest('.variantUpsell');
    let variant = null;
    let product = JSON.parse(upsellElement.dataset.product);

    // find the variant
    let options = [];
    upsellElement.querySelectorAll('.variantUpsellOptionsSelect').forEach(select => {
        options.push(select.value);
    });
    variant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (variant === null || variant === undefined) {
        upsellElement.querySelector(".variantUpsellATC").disabled = true;
        upsellElement.querySelector(".variantUpsellATC").textContent = "NOT AVAILABLE";
        return;
    }

    // update data-variant-id
    upsellElement.dataset.variantId = variant.id;

    // // update image
    upsellElement.querySelector('.variantUpsellHeaderImg').src = variant.featured_image.src;

    // update variant title
    upsellElement.querySelector('.variantUpsellHeaderInfoVariant').textContent = variant.title;


    // update price
    upsellElement.querySelector('.variantUpsellPriceReal').textContent = price(variant.price);
    upsellElement.querySelector('.variantUpsellPriceCompare').textContent = "";
    if (variant.compare_at_price > variant.price) {
        upsellElement.querySelector('.variantUpsellPriceCompare').textContent = price(variant.compare_at_price);
    }

    // update upsell ATC
    // check if the variant is in stock
    if (variant.available) {
        upsellElement.querySelector(".variantUpsellATC").disabled = false;
        upsellElement.querySelector(".variantUpsellATC").textContent = "ADD TO CART";
    } else {
        upsellElement.querySelector(".variantUpsellATC").disabled = true;
        upsellElement.querySelector(".variantUpsellATC").textContent = "SOLD OUT";
    }

}


// listen for add to cart
document.querySelectorAll('.variantUpsellATC')?.forEach(function (element) {
    element.addEventListener("click", async function () {
        element.classList.add("loading");

        // get variant ID from dropdown selector
        let variantID = parseInt(this.closest('.variantUpsell').dataset.variantId);

        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]

        };

        await addProduct(formData);

        // remove loading animation
        element.classList.remove("loading");

        // close dialog
        this.closest('.variantUpsell').close();
        await openCart();
    });
});

// check is coming from the cart
// if (document.referrer.includes("/cart")) {
//     openCart();
// }